import { render, staticRenderFns } from "./reminders.vue?vue&type=template&id=583d052c&scoped=true"
import script from "./reminders.vue?vue&type=script&lang=ts"
export * from "./reminders.vue?vue&type=script&lang=ts"
import style0 from "./reminders.vue?vue&type=style&index=0&id=583d052c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../.eden-mono/temp/node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583d052c",
  null
  
)

export default component.exports